import { schema } from "normalizr";
import { arrayOfAttachments } from "./schema.attachments.jsx";

const discussion = new schema.Entity(`discussions`);
const arrayOfDiscussions = [discussion];

discussion.define({
  attachments: arrayOfAttachments,
});

export { discussion, arrayOfDiscussions };
